/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge26 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])

	const fill: any = props.item.fill || "var(--force-contast-color)" 

	return <div className={`w-100 flex-centered edge-${id}`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		> 
			<path  fill={fill} d="M242.7,29.2c1.5-4.9,3-9.7,4.7-14.6c0.4-1.1-0.2-1.5-0.8-2c-2.2-2.1-2.5-4.7-0.9-6.8c1.9-2.5,5.2-3.2,7.6-1.7
				c2.6,1.6,3.2,5.2,1.1,7.8c-0.8,1-0.9,1.9-0.7,3.2c0.8,4,1.5,8.1,2.2,12.4c1-1.1,1.8-2.1,2.7-2.9c2.1-1.9,4.3-3.7,6.6-5.5
				c0.8-0.6,1.1-1.2,1.2-2.3c0.2-1.6,0.5-3.4,1.4-4.8c1.3-2.1,4.1-2.5,6.3-1.3c2.4,1.4,3,3.6,2.8,6.2c-0.2,2.3-1.4,3.7-3.9,4.3
				c-1.3,0.3-2,1-2.5,2.1c-2.1,4.1-4.3,8.2-5,12.8c-0.1,0.7-0.1,1.5,0.2,2.2c0.6,1.6,0.1,2.9-1.2,3.5c-2.2,1-4.5,2.2-6.9,2.5
				c-4.8,0.6-9.7,0.9-14.6,1c-1.7,0.1-3.5-0.5-5.1-1.1c-1.9-0.7-2.2-1.9-1.5-3.9c0.2-0.5,0.2-1.3,0-1.8c-2-4.6-4.1-9.1-6.3-13.6
				c-0.2-0.4-0.9-0.7-1.4-0.8c-2.2-0.3-4.1-1-4.8-3.4c-0.7-2.2-0.1-4.2,1.6-5.7c1.9-1.6,4-2.3,6.4-1.3c2.2,0.9,3.3,3.1,2.6,5.7
				c-0.4,1.5,0,2.2,1.1,3.1C238.2,25,240.5,27.2,242.7,29.2z M262.7,36.9c0.9-2.8,1.5-5.3,2.5-7.8c0.9-2.4,2.2-4.6,3.3-7
				c0.2-0.3,0.1-0.8,0.1-1.2c-0.4,0-0.9-0.2-1.2,0c-1,0.5-2,1-2.8,1.6c-3.1,2.2-5.6,5-7.6,8.3c-0.4,0.7-1.2,1.3-1.8,1.9
				c-0.5-0.8-1-1.6-1.4-2.5c-0.3-0.9-0.4-1.9-0.6-2.9c-0.6-3.8-1.2-7.7-1.8-11.5c-0.1-0.6-0.5-1.1-0.7-1.6c-0.2,0-0.3,0-0.5,0
				c-0.7,1.6-1.4,3.2-2,4.8c-1.6,4.1-2.5,8.3-2.6,12.7c0,0.7-0.4,1.8-0.9,1.9c-0.6,0.2-1.5-0.3-2.2-0.7c-0.5-0.2-0.8-0.7-1.2-1.1
				c-2.5-2.4-5-4.8-7.4-7.2c-0.4-0.3-0.8-0.6-1.2-0.9c-0.1,0.1-0.2,0.2-0.2,0.3c2.1,4.6,4.2,9.3,6.3,14
				C246.8,34.8,254.7,34.2,262.7,36.9z M238.2,42.1c8.7,1.8,16.8,1.1,24.9-2.1C257.2,36.2,242.4,37.3,238.2,42.1z M274.7,15.9
				c0-1.7-1.6-3.2-3.1-3.2c-1.5,0-2.8,1.6-2.8,3.3c0,1.7,1.3,3.1,3,3C273.4,19,274.7,17.6,274.7,15.9z M253.2,8.6
				c0-1.5-1.2-2.5-2.8-2.5c-1.6,0-3.1,1.4-3.1,2.8c0,1.4,1.5,2.8,3.1,2.8C251.8,11.7,253.2,10.1,253.2,8.6z M228.7,21.6
				c1.9,0,3.5-1.4,3.6-3.1c0.1-1.4-1-2.5-2.4-2.5c-1.6,0-3.5,1.9-3.5,3.5C226.3,20.7,227.2,21.6,228.7,21.6z"/>
			<path  fill={fill} d="M220.2,27.5c2,1.2,3.9,2.3,5.8,3.5c0.3,0.2,0.3,1,0.1,1.4c-0.1,0.2-0.9,0.3-1.3,0.2c-1.7-0.8-3.4-1.8-5-2.7
				c-0.3-0.2-0.5-0.8-0.5-1.2C219.1,28.4,219.6,28.1,220.2,27.5z"/>
			<path  fill={fill} d="M279.3,28.7c-0.4,0.7-0.5,1-0.8,1.2c-1.5,1.1-3,2.1-4.6,3.1c-0.3,0.2-0.9-0.2-1.4-0.3c0.1-0.4,0.1-1.1,0.4-1.3
				c1.5-1.1,3.1-2.2,4.7-3.2C277.9,28,278.6,28.5,279.3,28.7z"/>
			<path  fill={fill} d="M276.4,38c-0.5-0.4-1-0.8-1.5-1.2c0.4-0.4,0.7-1.1,1.2-1.3c1.2-0.4,2.6-0.6,3.9-0.7c0.4,0,1.1,0.4,1.2,0.8
				c0.1,0.3-0.3,1.1-0.7,1.2C279.3,37.3,277.9,37.5,276.4,38z"/>
			<path  fill={fill} d="M279.6,44.9c-1.5-0.7-3.1-1.3-4.5-2.1c-0.3-0.2-0.5-0.9-0.4-1.2c0.1-0.3,0.8-0.7,1.1-0.6c1.5,0.5,3,1.2,4.5,1.9
				c0.3,0.1,0.6,0.8,0.5,1.1C280.6,44.3,280.1,44.5,279.6,44.9z"/>
			<path  fill={fill} d="M227.3,41.2c-1.7,1.3-3.2,2.6-4.8,3.6c-0.7,0.4-1.4,0.1-1.3-1C221.4,41.7,224.9,39.9,227.3,41.2z"/>
			<path  fill={fill} d="M225.2,37c-0.4,0.2-0.8,0.6-1.3,0.6c-1.3,0.2-2.6,0.4-3.9,0.4c-0.4,0-0.9-0.3-1.2-0.6c-0.1-0.1,0.1-0.7,0.3-1
				C220.3,34.8,224,35,225.2,37z"/>
			<path  fill={fill} d="M273.4,16c-1,0.8-1.6,1.6-2.2,1.7c-1,0.1-1.8-0.7-1.6-1.8c0.1-0.6,1-1.5,1.5-1.5C271.7,14.4,272.4,15.2,273.4,16z"/>
			<path  fill={fill} d="M250.1,6.4c0.7,1.1,1.5,1.8,1.4,2.3c-0.2,0.7-1,1.2-1.6,1.7c-0.5-0.6-1.5-1.1-1.5-1.7C248.4,8.2,249.3,7.5,250.1,6.4z"/>
			<path  fill={fill} d="M227.3,18.4c0.6-0.4,1.2-1.1,1.9-1.1c1-0.1,1.8,0.6,1.5,1.6c-0.2,0.7-1,1.5-1.6,1.5c-0.6,0.1-1.2-0.8-1.8-1.3
				C227.3,18.9,227.3,18.6,227.3,18.4z"/>
		</svg>
	</div>
}

